import useIsAdminClientPreview from './global-state/redux/hooks/useIsAdminClientPreview';

const AdminClientPreviewInit = () => {
	useIsAdminClientPreview();
	return null;
};

export default AdminClientPreviewInit;
